"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldSpecifierInputDisplay = exports.isFieldSpecifierRequired = void 0;
const react_1 = __importDefault(require("react"));
const filter_model_1 = require("../../../filter.model");
const fields_1 = require("../fields");
const isFieldSpecifierRequired = (field) => [filter_model_1.FilterField.Field, filter_model_1.FilterField.Attribute].includes(field);
exports.isFieldSpecifierRequired = isFieldSpecifierRequired;
const FieldSpecifierInputDisplay = ({ selected, onUpdateValue, field, }) => (field === filter_model_1.FilterField.Category ? react_1.default.createElement(fields_1.CategorySelector, { onOptionChange: onUpdateValue, selected: selected })
    : field === filter_model_1.FilterField.Attribute ? react_1.default.createElement(fields_1.AttributeSelector, { onOptionChange: onUpdateValue, selected: selected })
        : react_1.default.createElement(fields_1.StandardFieldSelector, { onOptionChange: onUpdateValue, selected: selected }));
exports.FieldSpecifierInputDisplay = FieldSpecifierInputDisplay;
exports.default = exports.FieldSpecifierInputDisplay;
